import ProdScroller4i from '../../common/productscrollers.js';

function init(){
    // if page has been hit using back or forward buttons
    if (!!window.performance && window.PerformanceNavigationTiming.type === "back_forward") {
        const bodyPanel = document.getElementById("bodyPanel");
        bodyPanel.style.display = "none";
        location.url.reload();
        return;
    }

    initProductScroller();
}

function initProductScroller(){
    const scrollerDiv = document.getElementById("divHotScroller") || document.getElementById("divFavScroller");
    if (!scrollerDiv) {
        console.error("Product scroller div not found. Unable to initialize scroller.");
        return;
    }
    const scroller = new ProdScroller4i();
    scroller.init(scrollerDiv.id, 5, 3, 2);
}

init();